// extracted by mini-css-extract-plugin
export var active = "_a4-7";
export var container = "_a4-0";
export var evenWidth = "_a4-4";
export var large = "_a4-5";
export var outlet = "_a4-8";
export var slide = "_a4-2";
export var small = "_a4-6";
export var tab = "_a4-3";
export var tabs = "_a4-1";